module.exports = __webpack_public_path__ + "img/fb.fa65c8f1.png";